import styled from 'styled-components/macro';

import { visuallyHiddenStyles } from 'theme/themeConstants';

export const HiddenLegend = styled.legend`
  ${visuallyHiddenStyles}
`;
